import { useState } from 'react';
import type { AxiosInstance } from 'axios';
import { LdsBox } from '@lds/react';
import type { ManagedEnvironment } from '../../api/types';
import { AlbWafPage } from '../alb-waf/AlbWafPage';
import { TogglesPage, type Role } from '../toggles/TogglesPage';
import { GuardrailPanel } from './GuardrailPanel';

interface GuardrailsPageProps {
  role: Role;
  managedEnvironment: ManagedEnvironment;
  apiClient: AxiosInstance;
}

function AlbWafPolicies({ managedEnvironment, apiClient }: Omit<GuardrailsPageProps, 'role'>) {
  const [expanded, setExpanded] = useState(false);
  const [opened, setOpened] = useState(false);

  return (
    <GuardrailPanel title="Cadastro de policies" expanded={expanded} onChange={(open) => {
      setExpanded(open);
      if (open) setOpened(true);
    }}>
      {opened && <AlbWafPage embedded managedEnvironment={managedEnvironment} apiClient={apiClient} />}
    </GuardrailPanel>
  );
}

export function GuardrailsPage({ role, managedEnvironment, apiClient }: GuardrailsPageProps) {
  return (
    <LdsBox data-testid="guardrails-page">
      <TogglesPage key={managedEnvironment} role={role} apiClient={apiClient} guardrailPanels={{
        'alb-waf': <AlbWafPolicies managedEnvironment={managedEnvironment} apiClient={apiClient} />,
      }} />
    </LdsBox>
  );
}